import { gql } from 'graphql-tag';

export const checkFreeTrialEnrollmentEligibility = gql`
  query erCheckFreeTrialEnrollmentEligibility {
    erCheckFreeTrialEnrollmentEligibility {
      code
      status
      success
      message
    }
  }
`;

export const getFreeTrialCourses = gql`
  query erGetFreeTrialCourses {
    erGetFreeTrialCourses {
      code
      success
      message
      courses
    }
  }
`;
